import styled from "styled-components";

// Os estilos daqui tavam bugando com os estilos de App.css, entao removi os daqui.
export const MessageStyle = styled.div`

`;